export enum AuthEnum {
  AUTH_TOKEN = 'tkn_auth',
}

export enum ApiEnum {
  SIGN_IN = '/auth/sign-in',
  REFRESH_TOKEN = '/auth/refresh-token',
}
